module.exports = __webpack_public_path__ + "img/assembly.7b5e5ec9.svg";